module.exports = __webpack_public_path__ + "static/media/Banner2.b67e708c.jpg";